import { Link } from 'react-router-dom';
import * as constants from '@/constants';


const SidebarLogo = () => (
  <Link to={constants.ROUTE_HOME} className="flex items-center min-w-0">
    <img
      src="/images/logo_trans.png"
      alt="TypeHero Logo"
      className="h-7 w-auto flex-shrink-0"
    />
  </Link>
);

export default SidebarLogo;
